/**
 * MSW inline responses for the recruiting Activity tab and the "Log interview" flow
 * (`/apollo/people/recruiting/interviews/*`). Spread into the ENV-wide map in `inlineResponses.tsx`.
 *
 * People-module data must never come from a real export, so this is hand-authored, obviously-fake
 * data (@example.com, invented names).
 */
export const PEOPLE_INTERVIEWS_INLINE_RESPONSES: Record<
  string,
  Record<string, unknown> | unknown[]
> = {
  // Activity-tab list of logged interviews for an applicant.
  "/apollo/people/recruiting/interviews/for-application": [
    {
      applicationInterviewId: "ai-demo-0001",
      title: "Interview — Priya Nair (Software Engineer)",
      meetingDate: "2026-07-14T17:00:00Z",
      summaryShort:
        "Strong systems thinking; walked through the rating-engine project. Recommend advancing.",
      createdAt: "2026-07-14T17:45:00Z",
      createdBy: "recruiter@example.com",
    },
  ],

  // Full snapshot for the interview detail dialog.
  "/apollo/people/recruiting/interviews/ai-demo-0001": {
    applicationInterviewId: "ai-demo-0001",
    title: "Interview — Priya Nair (Software Engineer)",
    meetingDate: "2026-07-14T17:00:00Z",
    jamieUrl: "https://app.meetjamie.ai/meetings/16uc7dffc9oe",
    summaryMarkdown:
      "# Interview — Priya Nair\n\nStrong systems thinking. Walked through a rating engine that cut quote latency from 4s to under 400ms. Clear communicator; good sense for the LTL domain.\n\n**Recommendation:** advance to a technical round.",
    transcript:
      "Interviewer\n\n00:00 - 00:05\n\nThanks for joining, Priya. Tell me about a system you're proud of.\n\nPriya\n\n00:05 - 00:20\n\nI built a rating engine that cached carrier responses and cut quote latency dramatically.",
    notes: "Great first screen. Scheduling a technical round.",
    participantsJson:
      '[{"name":"Recruiter","email":"recruiter@example.com"},{"name":"Priya Nair","email":"priya.nair@example.com"}]',
    actionItemsJson:
      '[{"content":"Schedule technical round with the platform team","completed":false,"assignee":{"name":"Recruiter","email":"recruiter@example.com"}},{"content":"Send take-home brief","completed":true}]',
    createdBy: "recruiter@example.com",
  },

  // The current user's recent Jamie meetings, offered in the Log interview picker.
  "/apollo/people/recruiting/interviews/recent-meetings": [
    {
      jamieMeetingId: "16uc7dffc9oe",
      title: "Interview — Priya Nair",
      meetingDate: "2026-07-14T17:00:00Z",
    },
    {
      jamieMeetingId: "16v59cs5hm4g",
      title: "Interview — Marcus Bell",
      meetingDate: "2026-07-12T15:00:00Z",
    },
  ],

  // POST preview — the parsed meeting for the review step.
  "/apollo/people/recruiting/interviews/preview": {
    jamieMeetingId: "16uc7dffc9oe",
    jamieUrl: "https://app.meetjamie.ai/meetings/16uc7dffc9oe",
    title: "Interview — Priya Nair",
    meetingDate: "2026-07-14T17:00:00Z",
    summaryShort:
      "Strong systems thinking; walked through the rating-engine project.",
    summaryMarkdown:
      "# Interview — Priya Nair\n\nStrong systems thinking. Recommend advancing to a technical round.",
    participants: [
      { name: "Recruiter", email: "recruiter@example.com" },
      { name: "Priya Nair", email: "priya.nair@example.com" },
    ],
    actionItems: [
      {
        content: "Schedule technical round with the platform team",
        assignee: "Recruiter",
      },
      { content: "Send take-home brief", assignee: undefined },
    ],
  },

  // POST log — returns the new interview id.
  "/apollo/people/recruiting/interviews/log": {
    applicationInterviewId: "ai-demo-0001",
  },
};
